module.exports = __webpack_public_path__ + "img/weightlifter.534d6def.png";